import {
  assoc,
  assocPath,
  compose,
  cond,
  either,
  evolve,
  identity,
  ifElse,
  includes,
  isNil,
  map,
  modify,
  modifyPath,
  pathOr,
  pluck,
  propEq,
  reject,
  T
} from 'ramda';
import { GranteeTypeEnum } from '@fasstech/oip-core/entities/Grantee/enums';
import { WaiverRequestTypeEnum } from '@fasstech/oip-core/entities/WaiverRequest/enums';

export const formatExtraDefaultValues = (beneficiaries) => (props) => {
  const beneficiariesTypes = compose(reject(isNil), pluck('type'))(beneficiaries);

  const customerAvailableWaiverRequests = pathOr(
    [],
    ['offer', 'packs', 0, 'pricings', 0, 'availableWaiverRequests'],
    props
  );

  const hasCoupleDiscount = includes('Remise couple', customerAvailableWaiverRequests);

  const isOnlySpouseDiscount =
    includes(GranteeTypeEnum.SPOUSE, beneficiariesTypes) && hasCoupleDiscount;

  if (isOnlySpouseDiscount) {
    const updatedPacks = map((pack) => {
      return modify(
        'pricings',
        map((pricing) =>
          ifElse(
            () => either(propEq('type', 'SPOUSE'), propEq('type', null))(beneficiaries[0]),
            assocPath(['waiverRequests', 0, 'code'], 'Remise couple'),
            assocPath(['waiverRequests', 0, 'code'], 'Aucune')
          )(pricing)
        ),
        pack
      );
    });

    return modifyPath(['offer', 'packs'], updatedPacks, props);
  } else {
    return props;
  }
};

export const formatExtraDataBeforeSubmit = (props) => {
  const mapCodeToType = cond([
    [
      propEq('code', 'Offre de bienvenue'),
      (waiver) => assoc('type', 'WELCOME_OFFER_DISCOUNT', waiver)
    ],
    [
      propEq('code', 'Offre créateurs d\'entreprise'),
      (waiver) => assoc('type', WaiverRequestTypeEnum.BUSINESS_CREATION_DISCOUNT, waiver)
    ],
    [propEq('code', 'Remise couple'), (waiver) => assoc('type', 'COUPLE_DISCOUNT', waiver)],
    [T, identity]
  ]);

  const addTypeToWaiverRequests = map(
    evolve({
      pricings: map(
        evolve({
          waiverRequests: map(mapCodeToType)
        })
      )
    })
  );

  return addTypeToWaiverRequests(props);
};
